<div class="container">
  <h1 class="placeholder-glow">
    @if (album) {
      {{ album.title }}
    } @else {
      <span class="placeholder col-6"></span>
    }
  </h1>

  <h2 class="h4 text-muted mb-4">{{ album?.description }}</h2>

  <h5 class="text-body-secondary placeholder-glow">
    @if (album) {
      {{ total }}
      {{ total > 1 ? 'fotografías' : 'fotografía' }} •
      {{ album.date | date: 'dd/MM/yy' }}
    } @else {
      <span class="placeholder col-2"></span>
    }
  </h5>

  <div class="row g-2">
    @if (album?.photos) {
      @for (photo of album?.photos; track photo.id) {
        <div class="col-md-3">
          <img
            [src]="photo.image_url"
            class="card-img cursor-zoom object-fit-cover"
            data-bs-toggle="modal"
            [attr.data-bs-target]="'#imageModal' + $index"
            [alt]="photo.caption"
            height="210"
          />
        </div>
      } @empty {
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; track i) {
          <div class="col-md-3 placeholder-glow">
            <span class="placeholder w-100" style="height: 210px"></span>
          </div>
        }
      }
    } @else {
      <div class="col-12">
        <div class="alert alert-secondary text-center" role="alert">
          No hay fotos disponibles.
        </div>
      </div>
    }

    @if (album) {
      <app-pagination
        [(page)]="params.page"
        [total]="total"
        [limit]="params.limit"
        (pageChange)="getAlbum()"
      />
    } @else {
      <div class="d-flex justify-content-end placeholder-glow">
        <span class="placeholder col-4" style="height: 40px"></span>
      </div>
    }
  </div>
</div>

@for (photo of album?.photos; track photo.id) {
  <div
    class="modal fade"
    [id]="'imageModal' + $index"
    tabindex="-1"
    [attr.aria-labelledby]="'imageModalLabel' + $index"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" [id]="'imageModalLabel' + $index">
            Imagen {{ $index + 1 }}
          </h1>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <img
            [src]="photo.image_url"
            class="w-100 rounded"
            [alt]="photo.caption"
          />
        </div>
      </div>
    </div>
  </div>
}
